import React from 'react';

// eslint-disable-next-line no-unused-vars
export const SSRScroller = ({ render, scrollTo: $dontcare, ...props }) => (
  <section {...props}>{render(() => {})}</section>
);



// WEBPACK FOOTER //
// ./app/components/SSRScroller.js